import { TableProps } from 'antd';
import { FC } from 'react';
import { StyledExpandadedTable } from './Table.styles';

const ExpandedTable: FC<TableProps<any>> = (props) => {
    return <StyledExpandadedTable {...props}></StyledExpandadedTable>;
};
export default ExpandedTable;
